import { render, staticRenderFns } from "./user_shoppingcart.vue?vue&type=template&id=56927d79&scoped=true&"
import script from "./user_shoppingcart.vue?vue&type=script&lang=js&"
export * from "./user_shoppingcart.vue?vue&type=script&lang=js&"
import style0 from "./user_shoppingcart.vue?vue&type=style&index=0&id=56927d79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56927d79",
  null
  
)

export default component.exports